import { Injectable } from '@angular/core';
import { retry, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IAccountBundleMember } from '../../interfaces/account/account-bundle-member';
import { Dictionary } from '../../classes/dictionary';
import { SharedService } from '../shared.service';

@Injectable({
  providedIn: 'root'
})
export class AccountBundleService {

  private readonly accountBundleUrl: string = '/ui-pages/account-bundle/{sessionId}';

  private readonly baseHeaders = new HttpHeaders()
    .set("request-origin", "csr-portal");

  constructor(
    private readonly http: HttpClient,    
    private readonly sharedService: SharedService    
  ) { }

  public getAccountMembers(region: string, sessionId: string): Observable<IAccountBundleMember[]> {
    let url = this.sharedService.getBaseUrlByRegion(region) + this.accountBundleUrl
      .replace('{sessionId}', sessionId);
    return this.http.get<IAccountBundleMember[]>(url, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public modifyAccountMembersSelection(region: string, sessionId: string, memberSelectionDict: Dictionary): Observable<any> {
    let memberSelections: string[] = [];
    let items = memberSelectionDict.items;
    for(let item in items) {
      if (items[item]) {
        memberSelections.push(item);
      }
    }
    let url = this.sharedService.getBaseUrlByRegion(region) + this.accountBundleUrl
      .replace('{sessionId}', sessionId);
    return this.http.put<string[]>(url, memberSelections, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }


}
